import request from '@/utils/requestWrapper'

// 获取好友列表
export function getFriendList (params) {
  return request({
    url: '/api/friend/list',
    method: 'get',
    params
  })
}

// 搜索好友
export function searchFriends (keyword, searchType = 'phone') {
  return request({
    url: '/friend/search',
    method: 'get',
    params: { keyword, searchType }
  })
}

// 添加好友
export function addFriend (data) {
  return request({
    url: '/friend/add',
    method: 'post',
    data
  })
}

// 删除好友
export function deleteFriend (friendId, userId) {
  // 参数验证，确保friendId和userId都是有效类型
  if (!friendId || isNaN(Number(friendId))) {
    return Promise.reject(new Error('无效的好友ID'))
  }
  if (!userId) {
    return Promise.reject(new Error('无效的用户ID'))
  }

  // 确保friendId是数字类型
  const numericFriendId = Number(friendId)

  return request({
    url: `/friend/${numericFriendId}`,
    method: 'delete',
    params: {
      userId
    }
  })
}

// 同意好友请求
export function acceptFriend (requestId) {
  return request({
    url: `/friend/request/${requestId}/accept`,
    method: 'post'
  })
}

// 拒绝好友请求
export function rejectFriend (requestId) {
  return request({
    url: `/friend/request/${requestId}/reject`,
    method: 'post'
  })
}

// 获取好友请求列表
export function getFriendRequests (params) {
  return request({
    url: '/friend/requests',
    method: 'get',
    params
  })
}

// 获取未读消息数量
export function getUnreadCount (params) {
  return request({
    url: '/api/message/unread/count',
    method: 'get',
    params
  })
}
